import { SystemFuncArgs } from '$legacyecstatic';
import MapboxCamera from 'editor/components/map/MapboxCamera';
import MapboxMap from 'editor/components/map/MapboxMap';
import { Components } from '../../components';

export const manageCameraComponents = [MapboxMap, MapboxCamera];

export function manageCamera(args: SystemFuncArgs<Components>): void {
  const { components } = args;
  const mapComp = components.get(MapboxMap);
  const cameraComp = components.get(MapboxCamera);

  if (mapComp.map && cameraComp.updated.size) {
    const { viewport, screenCoordinates, locked, fitToBounds } =
      cameraComp.tracked;

    if (cameraComp.updated.has('fitToBounds') && fitToBounds) {
      mapComp.map.fitBounds(fitToBounds.bounds, {
        padding: fitToBounds.padding,
      });
    }

    if (cameraComp.updated.has('viewport') && viewport) {
      mapComp.map
        .setCenter([viewport.longitude, viewport.latitude])
        .setPitch(viewport.pitch)
        .setBearing(viewport.bearing)
        .zoomTo(viewport.zoom, { animate: true });
    }

    if (cameraComp.updated.has('screenCoordinates') && screenCoordinates) {
      mapComp.map.fitScreenCoordinates(
        screenCoordinates.topLeft,
        screenCoordinates.bottomRight,
        screenCoordinates.bearing
      );

      mapComp.map.once('moveend', () => {
        cameraComp.tracked.locked = true;
      });
    }

    if (cameraComp.updated.has('locked')) {
      if (locked) {
        const maxBounds = mapComp.map.getBounds();
        mapComp.map.setMaxBounds(maxBounds);
        mapComp.map.dragRotate.disable();
        mapComp.map.touchZoomRotate.disableRotation();
        mapComp.map.keyboard.disableRotation();
      } else {
        mapComp.map.setMaxBounds();
        mapComp.map.dragRotate.enable();
        mapComp.map.touchZoomRotate.enableRotation();
        mapComp.map.keyboard.enableRotation();
      }
    }

    cameraComp.updated.clear();
  }
}
